/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { Button } from '@mui/material';
import type { ReactNode } from 'react';

type BannerButtonProps = {
	children: ReactNode;
	onClick?: () => void;
	href?: string;
	dataTestId?: string;
};

export function BannerButton( { children, onClick, dataTestId = 'banner-button', href }: BannerButtonProps ): ReactNode {
	return (
		<Button
			target={ '_blank' }
			component={ href ? 'a' : 'button' }
			data-testid={ dataTestId }
			variant={ 'contained' }
			onClick={ onClick }
			href={ href }
			sx={ {
				fontWeight: '400',
				lineHeight: '20px',
				fontSize: '12px',
				height: '24px',
				flexShrink: 0,
				padding: 0,
				paddingLeft: '5px',
				paddingRight: '5px'
			} }
		>
			{ children }
		</Button>
	);
}
